export enum BackgroundColorType {
    PURPLE,
    ORANGE,
}